
import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
import { deepClone, RequestPaging, copyClipboard, flatten } from "@/utils/util";
import LsForm from "@/components/ls-form.vue";
import LsDialog from "@/components/ls-dialog.vue";
import MaterialSelect from "@/components/material-select/index.vue";
import ThreePreview from "@/components/material-select/three-preview.vue";
import { readPsdFile } from "@/utils/psd.js";
import {
  apiModelEffectLists,
  apiModelEffectAdd,
  apiModelEffectEdit,
  apiModelEffectDelete,
  apiModelEffectFastEdit,
  apiModelDetail,
} from "@/api/model";

@Component({
  components: {
    LsForm,
    LsDialog,
    MaterialSelect,
    ThreePreview,
  },
})
export default class Dialog extends Vue {
  visible = {
    val: false,
  };

  @Prop() value: any;
  @Prop({ default: 0 }) model_id: any;
  @Prop({ default: 0 }) model_item_id: any;
  @Provide("visible")
  visibleVal = this.visible;

  // props
  @Prop({ default: "" }) title!: string; // 弹窗标题
  @Prop({ default: false }) disabled!: boolean; // 是否禁用
  @Prop({ default: false }) async!: boolean; // 是否开启异步关闭
  @Prop({ default: true }) clickModalClose!: boolean; // 点击遮罩层关闭对话窗口
  pager: RequestPaging = new RequestPaging({ size: 99 });
  activeName = "professional"; //professional,fast

  mode = "add";
  formVisible = false;
  formData = [
    {
      type: "input",
      label: "名称",
      key: "name",
      rules: [{ required: true, message: "请输入名称", trigger: "blur" }],
    },

    {
      type: "input",
      label: "定制部位名称",
      key: "design_name",
    },
    {
      type: "images",
      label: "效果图",
      key: "images",
      limit: 5,
      size: "1600px*1600px",
    },
    {
      type: "input",
      label: "排序",
      key: "sort",
    },
    {
      type: "radio",
      label: "状态",
      key: "status",
      list: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
    },
  ];

  dataForm: any = {
    id: 0,
    model_id: 0,
    model_item_id: 0,
    name: "",
    design_name: "",
    sort: 0,
    status: 1,
    model_url: "",
    more_spec: 0,
    img_layer: 1,
    is_diy: 1,
    is_differ: 0,
    factory_thumb: 0,
    img_suffix: "jpg",
    is_change: 0,
  };
  imgNum = 0;
  imgLayerNum = "";
  modelList: any = [
    {
      url: "",
      scale: "6,6,6",
      rotation: "0,0,0",
      position: "0,0,0",
    },
  ];
  psdList: any = [];
  images = [];
  specImages: any = [];

  skuDiyData: any = [];
  copySkuDiyData: string = "";
  selectSpec: any = [];

  model_url = "";

  imagesArr: any = [];

  effectimg_type = 1;
  spec_value_list: any = [];

  @Watch("model_url")
  onModelUrlChange(val: any, oldVal: any) {
    this.selectSpec.forEach((element: any) => {
      this.skuDiyData[element].model.forEach((item: any) => {
        item.url = this.model_url;
      });
    });
  }
  // methods
  handleEvent(type: "cancel" | "confirm") {
    if (!this.async || type === "cancel") this.close();
    if (type === "confirm") {
    }
  }

  mulitpeSpec() {
    this.selectSpec = [];
    this.skuDiyData.forEach((element: any, index: any) => {
      this.selectSpec.push(index);
    });
  }

  mulitpeImg(value: string, index: number) {
    this.selectSpec.forEach((element: any) => {
      this.$set(this.skuDiyData[element].images, index, value);
    });
  }

  getList() {
    let params = {
      model_id: this.model_id,
      // model_item_id: this.model_item_id,
      is_fast: this.activeName == "fast" ? 1 : 0,
    };
    this.pager.request({
      callback: apiModelEffectLists,
      params: params,
    });
  }
  changeImgNum() {
    let imagesArr = [];
    for (let i = 0; i < this.imgNum; i++) {
      imagesArr.push("");
    }
    this.imagesArr = imagesArr;
    this.skuDiyData.forEach((element: any, index: number) => {
      if (this.selectSpec.length) {
        if (this.selectSpec.includes(index)) {
          for (let i = 0; i < this.imgNum; i++) {
            element.images.push("");
          }
        }
      } else {
        for (let i = 0; i < this.imgNum; i++) {
          element.images.push("");
        }
      }
    });
  }
  changeImgLayerNum() {
    this.skuDiyData.forEach((element: any) => {
      element.img_layer = this.imgLayerNum;
    });
  }
  copyData() {
    copyClipboard(JSON.stringify(this.skuDiyData));
    this.$message.success("复制成功");
  }
  zhantie() {
    this.skuDiyData = JSON.parse(this.copySkuDiyData);
  }
  deleteSkuDiyData(index: number) {
    this.skuDiyData.splice(index, 1);
  }
  addModel(index = 0) {
    if (this.effectimg_type == 1) {
      if (this.dataForm.more_spec == 1) {
        this.skuDiyData[index]["model"].push({
          url: "",
          scale: "6,6,6",
          rotation: "0,0,0",
          position: "0,0,0",
        });
      } else {
        this.modelList.push({
          url: "",
          scale: "6,6,6",
          rotation: "0,0,0",
          position: "0,0,0",
        });
      }
    }
  }

  onTrigger() {
    if (this.disabled) return;
    this.open();
  }

  close() {
    this.visible.val = false;

    this.$emit("close");
  }

  open() {
    this.visible.val = true;
    this.$emit("open");
    this.getList();
  }

  async handleAdd() {
    this.mode = "add";
    this.selectSpec = [];
    this.model_url = "";
    this.imagesArr = [];
    this.skuDiyData = [];
    this.imgNum = 0;
    this.modelList = [
      {
        url: "",
        scale: "6,6,6",
        rotation: "0,0,0",
        position: "0,0,0",
      },
    ];
    this.psdList = [];
    this.dataForm = {
      id: 0,
      model_id: 0,
      // model_item_id: 0,
      name: "",
      design_name: "",
      sort: 0,
      status: 1,
      model_url: "",
      more_spec: 0,
      is_diy: 1,
      is_differ: 0,
      img_suffix: "jpg",
      is_change: 0,
      factory_thumb: 0,
    };
    this.specImages = [];
    await this.getSpecValue();
    this.formVisible = true;
  }

  async handleEdit(row: any) {
    this.dataForm = row;
    this.selectSpec = [];
    this.model_url = "";
    this.imagesArr = [];
    this.skuDiyData = [];
    this.imgNum = 0;
    delete this.dataForm.create_time;
    delete this.dataForm.update_time;
    delete this.dataForm.delete_time;
    delete this.dataForm.model_name;
    await this.getSpecValue();

    if (this.dataForm.psd) {
      let psdListData = JSON.parse(this.dataForm.psd);
      if (this.dataForm.more_spec == 1) {
        for (let i in this.skuDiyData) {
          //过滤调已删除的规格
          this.psdList[i] = psdListData.find(
            (item: any) => item.sku == this.skuDiyData[i].name,
          );
        }
      } else {
        this.psdList = psdListData;
      }
    }
    if (this.dataForm.more_spec == 0) {
      this.images =
        this.dataForm.images != "" ? this.dataForm.images.split(",") : [];
      this.modelList = this.dataForm.model_url
        ? JSON.parse(this.dataForm.model_url)
        : [
            {
              url: "",
              scale: "6,6,6",
              rotation: "0,0,0",
              position: "0,0,0",
            },
          ];
    }
    this.mode = "edit";
    this.formVisible = true;
  }
  // 设置字段名称
  setFields(prev: any, next: any) {
    let valueArr: any[] = [prev, next];
    valueArr = valueArr.filter((item) => item.value !== undefined);
    const ids = flatten(valueArr.map((item) => item.ids)).join();
    const value = flatten(valueArr.map((item) => item.value));
    return {
      id: prev.id ? prev.id : "",
      ids: ids,
      value,
      spec_value_str: value.join(),
      image: prev.image ? prev.image : next.image,
      cost_price: prev.cost_price ? prev.cost_price : "",
      volume: prev.volume ? prev.volume : 0,
      weight: prev.weight ? prev.weight : 320,
      length: prev.length ? prev.length : 20,
      width: prev.width ? prev.width : 15,
      height: prev.height ? prev.height : 3,
    };
  }
  getTableData(arr: any[]) {
    arr = JSON.parse(JSON.stringify(arr));
    return arr.reduce(
      (prev, next) => {
        const newArr: any[] = [];
        for (let i = 0; i < prev.length; i++) {
          if (!next.length) {
            newArr.push(this.setFields(prev[i], {}));
          }
          for (let j = 0; j < next.length; j++) {
            next[j].ids = j;
            newArr.push(this.setFields(prev[i], next[j]));
          }
        }
        return newArr;
      },
      [{}],
    );
  }
  getSpecValue() {
    return new Promise((resolve, reject) => {
      let sku_diy_data_copy = this.dataForm.sku_diy_data
        ? deepClone(JSON.parse(this.dataForm.sku_diy_data))
        : [];
      let sku_diy_data = this.dataForm.sku_diy_data
        ? JSON.parse(this.dataForm.sku_diy_data).map((item: any) => item.name)
        : [];
      apiModelDetail({ id: this.model_id }).then((res) => {
        this.spec_value_list = res.spec_value_list;
        const specList = res.spec_value.map((item: any) => item.spec_list);
        let spec_list = this.getTableData(specList);
        let skuDiyDataCopy: any = [];
        for (let specIndex in spec_list) {
          let spec = spec_list[specIndex];
          if (sku_diy_data.includes(spec.spec_value_str) > 0) {
            skuDiyDataCopy[specIndex] = sku_diy_data_copy.find(
              (item: any) => item.name == spec.spec_value_str,
            );
          } else {
            skuDiyDataCopy[specIndex] = {
              name: spec.spec_value_str,
              images: [],
              img_layer: 1,
              model: [
                {
                  url: "",
                  scale: "6,6,6",
                  rotation: "0,0,0",
                  position: "0,0,0",
                },
              ],
            };
          }
        }
        this.effectimg_type = res.effectimg_type;
        this.skuDiyData = skuDiyDataCopy;
        resolve(skuDiyDataCopy);
      });
    });
  }

  handleChangeValue(id: number, value: number, key: string) {
    apiModelEffectFastEdit({ id: Number(id), [key]: value }).then((res) => {
      this.$message.success("success");
      this.getList();
    });
  }

  handleSubmit() {
    this.dataForm.model_id = this.model_id;
    // this.dataForm.model_item_id = this.model_item_id;

    if (this.dataForm.more_spec == 0) {
      this.dataForm.model_url = JSON.stringify(this.modelList);
      this.dataForm.images = this.images.join(",");
    } else {
      this.dataForm.sku_diy_data = JSON.stringify(this.skuDiyData);
    }
    if (this.effectimg_type == 2) {
      this.dataForm.psd = JSON.stringify(this.psdList);
    }
    if (this.mode == "add") {
      this.dataForm.is_fast = this.activeName == "fast" ? 1 : 0;
      apiModelEffectAdd({ ...this.dataForm }).then((res) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiModelEffectEdit({ ...this.dataForm }).then((res) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  handleDelete(id: number) {
    apiModelEffectDelete({ id: id }).then((res) => {
      this.getList();
    });
  }

  handleCopy(row: any) {
    let params = deepClone(row);
    delete params.id;
    delete params.create_time;
    delete params.update_time;
    delete params.delete_time;
    params.sort = 1;
    apiModelEffectAdd(params).then((res) => {
      this.getList();
    });
  }
  async loadPsd(file: any, type: number, index: number) {
    try {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const psd = await readPsdFile(file);
      if (type == 1) {
        this.psdList = [{ ...psd, ...{ sku: "common" } }];
      } else if (type === 2) {
        let psdList = JSON.parse(JSON.stringify(this.psdList));
        this.skuDiyData.forEach((item: any, index: number) => {
          if (this.selectSpec.includes(index)) {
            psdList[index] = { ...psd, ...{ sku: item.name } };
          } else {
            psdList[index] = psdList[index] || {
              file_id: "",
              file_name: "",
              layerNames: [],
              sku: "",
              thumb: "",
              url: "",
            };
          }
        });
        this.$set(this, "psdList", psdList);
      } else if (type === 3) {
        this.$set(this.psdList, index, {
          ...psd,
          ...{ sku: this.skuDiyData[index].name },
        });
      }
      loading.close();
    } catch (e: any) {
      console.log(e);
      this.$message.error(e.message);
    }
  }

  goPreivew(url: any) {
    if (!url) {
      url = this.psdList[0]["url"];
    }
    window.open(
      `${
        window.location.origin
      }/platform/design/psd-preview?psd=${encodeURIComponent(url)}`,
      "_blank",
    );
  }
  created() {}
}
